import StudentAdvicessServices from "../services/academic/StudentAdvicessServices"
export const Advisor = {
    namespaced: true,
    state: { 
        AllowedCoursesConstraint: null,
        ForbiddenCourseContraint: null,
        StudentRegistrationApproval: null,
        StudentDropRule: null,
        AdvisingStatus: null
    },
    mutations: {
        studentStatus(state , data){
            state.AllowedCoursesConstraint = data.AllowedCoursesConstraint
            state.ForbiddenCourseContraint = data.ForbiddenCourseContraint
            state.StudentRegistrationApproval = data.StudentRegistrationApproval
            state.StudentDropRule = data.StudentDropRule
            state.AdvisingStatus = data.AdvisingStatus
        }
    },
    getters: {
        
    },
    actions: {
        AdvisorStatus({commit},studentId){
            return StudentAdvicessServices.StudentAdvisingStatus(studentId)
            .then(data=>{
                console.log('store',data.data[0])
                commit ('studentStatus',data.data[0]);
                return Promise.resolve(data);
            })
        }
    }
}